module.exports = __webpack_public_path__ + "static/media/DaisyIsibor.174551ac.jpg";